<template>
  <div
    class="kd-image-dropzone"
    :class="{
      'kd-image-dropzone--dragover': dragInProgress,
    }"
    @dragenter="onDragEnter"
    @dragover="onDragOver"
    @dragleave="onDragLeave"
    @drop="onDrop"
  >
    <div class="kd-image-dropzone__inner-wrapper">
      <!-- <drop class="kd-image-dropzone__dropzone" @drop="handleDrop"> -->
      <div
        class="kd-layer-settings-unit__headline"
        v-if="this.ACTIVE_IMAGE_URL"
      >
        Bild ersetzen
      </div>

      <kd-image-list
        :imageUrls="USER_IMAGES"
        :show-spinner="uploadInProgress"
        v-model="selectedImageUrl"
        @change="setSelectedImage"
      ></kd-image-list>
      <form
        :action="uploadUrl"
        ref="uploadForm"
        method="post"
        encType="multipart/form-data"
        @submit="imageFormSubmitted"
      >
        <input
          type="file"
          name="file"
          ref="fileInput"
          accept="image/*"
          style="display: none"
          @change="onFileToUploadChange"
        />
        <kd-button-medium
          @click.native="openFileChooser"
          text="Neues Bild hochladen"
        ></kd-button-medium>
      </form>
      <div class="kd-image-dropzone__dragndrop-hint">… oder einfach hierher ziehen</div>
      <!-- <vue-dropzone
        ref="myVueDropzone"
        id="dropzone"
        :options="dropzoneOptions"
        :headers="dropzoneOptions.headers"
      ></vue-dropzone> -->
    <!-- </drop> -->
    </div>
    <div class="kd-image-dropzone__dragover-container">
      <span class="kd-image-dropzone__dragover-text">Bild hier ablegen</span>
    </div>
  </div>
</template>

<script>
import * as log from 'loglevel';
import axios from 'axios';
// import { Drag, Drop } from 'vue-drag-drop';
import { mapGetters, mapMutations } from 'vuex';
// import vue2Dropzone from 'vue2-dropzone';
import KdButtonMedium from '@/components/KdButtonMedium.vue';
import KdImageList from '@/components/KdImageList.vue';

import {
  ACTIVE_SIDE_ID,
  ACTIVE_LAYER_ID,
  ACTIVE_IMAGE_URL,
  USER_IMAGES,
  CARD_ID,
  SESSION_ID,
} from '@/store/getter-types';
import {
  SET_IMAGE_LAYER_URL,
  SET_IMAGE_URL_FOR_SELECTED_LAYER,
  ADD_USER_IMAGE,
  RESET_IMAGE_LAYER_TRANSFORMATIONS,
} from '@/store/mutation-types';

export default {
  data() {
    return {
      // because there can be multiple uploads at the same time,
      // caused by various layers, we need to keep track
      uploads: [
        // filename,
        // sideId,
        // layerId,
      ],
      finishedUploads: [], // same structure as on top
      selectedImageUrl: '',
      dragInProgress: false, // if a file is currently being dragged over the dropzone
      lastDragEnterEl: null,
      // dropzoneOptions: {
      //   // url: `${process.env.VUE_APP_IMAGE_SERVER}/upload/user`,
      //   url: process.env.VUE_APP_IMAGE_SERVER + '/upload/user',
      //   acceptedFiles: 'image/*',
      //   thumbnailHeight: 38,
      //   headers: {
      //     "Accept": "application/json",
      //     // "Content-Type": "multipart/form-data", // causes a CORS error
      //     'Cache-Control': null,
      //     'X-Requested-With': null,
      //   },
      // },
    };
  },
  computed: {
    ...mapGetters([
      ACTIVE_SIDE_ID,
      ACTIVE_LAYER_ID,
      ACTIVE_IMAGE_URL,
      USER_IMAGES,
      CARD_ID,
      SESSION_ID,
    ]),
    uploadInProgress() {
      return this.uploads.length > 0;
    },
    uploadUrl() {
      return `${process.env.VUE_APP_IMAGE_SERVER}/upload/user`;
    },
    uploadedImageUrls() {
      return this.finishedUploads.map(image => image.url);
    },
  },
  methods: {
    ...mapMutations([
      SET_IMAGE_LAYER_URL,
      SET_IMAGE_URL_FOR_SELECTED_LAYER,
      RESET_IMAGE_LAYER_TRANSFORMATIONS,
      ADD_USER_IMAGE,
    ]),
    onDragEnter(ev) {
      // if (!ev.target === this.$refs.dropzone) { return; }
      this.lastDragEnterEl = ev.target;
      this.dragInProgress = true;
    },
    onDragLeave(ev) {
      if (this.lastDragEnterEl === ev.target) {
        this.dragInProgress = false;
        this.lastDragEnterEl = null;
      }
    },
    onDragOver(ev) {
      if (!ev.target === this.$refs.dropzone) { return; }
      ev.preventDefault();
    },
    onDrop(ev) {
      ev.preventDefault();
      const dt = ev.dataTransfer;
      /* eslint-disable prefer-destructuring */
      const files = dt.files;
      this.dragInProgress = false;
      this.lastDragEnterEl = null;
      this.uploadFile(files[0]);
    },
    // handleDrop(data, event) {
    //   event.preventDefault();
    //   const files = event.dataTransfer.files;
    //   const filenames = [];
    //   for (let i = 0; i < files.length; i++) {
    //     filenames.push(files.item(i).name);
    //   }
    //   alert(`You dropped files: ${JSON.stringify(filenames)}`);
    // },
    openFileChooser() {
      this.$refs.fileInput.click();
    },
    onFileToUploadChange() {
      this.imageFormSubmitted();
    },
    setSelectedImage(imageUrl) {
      this.SET_IMAGE_URL_FOR_SELECTED_LAYER(imageUrl);
      this.RESET_IMAGE_LAYER_TRANSFORMATIONS();
    },
    imageFormSubmitted(ev) {
      if (ev) { ev.preventDefault(); } // if this was triggered by an actual submit
      const fileInput = this.$refs.fileInput;
      if (!fileInput || !fileInput.files) {
        log.warn('Image upload without specifying an image does not work!');
        return;
      }
      const file = fileInput.files[0]; // only one image, take the first one
      this.uploadFile(file);
    },
    onUploadFinished(response) {
      log.debug('Response after uploading the image: ', response);
      if (response && response.data && response.data.originalFilename) {
        const { originalFilename } = response.data;
        log.debug('Filename: ', originalFilename);
        /* eslint-disable max-len */
        const iUpload = this.uploads.findIndex(upload => upload.originalFilename === originalFilename);
        if (iUpload > -1) {
          const uploadClone = {
            ...this.uploads[iUpload],
            url: response.data.url,
          };
          // this.finishedUploads.unshift(uploadClone);
          this.ADD_USER_IMAGE(response.data.url);
          this.uploads.splice(iUpload, 1); // remove entry, no longer needed
          // TODO: Set image layer for the layer upload.layerId / upload.sideId
          // TODO: Change to URL instead of filename
          this.RESET_IMAGE_LAYER_TRANSFORMATIONS();
          this.SET_IMAGE_LAYER_URL({
            sideId: uploadClone.sideId,
            layerId: uploadClone.layerId,
            url: uploadClone.url,
          });
        }
      }
    },
    onUploadFailed(error) {
      // TODO: Build modal component or find modal component lib
      /* eslint-disable no-alert */
      log.error('Could not upload image', error);
      alert('Leider gab es ein Problem beim Upload des Bildes.'); // TODO: Show nicer modal?
    },
    uploadFile(file) {
      if (!file) { log.error('Could not upload file, it is null'); return; }
      const formData = new FormData();
      formData.append('file', file, file.name);
      formData.append('text', `${this.SESSION_ID}`);
      this.uploads.push({
        sideId: JSON.parse(JSON.stringify(this.ACTIVE_SIDE_ID)),
        layerId: JSON.parse(JSON.stringify(this.ACTIVE_LAYER_ID)),
        originalFilename: file.name,
      }); // TODO: maybe add to Vuex instead!?
      axios.post(this.uploadUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then(this.onUploadFinished).catch(this.onUploadFailed);
    },
  },
  components: {
    KdButtonMedium,
    KdImageList,
    // vueDropzone: vue2Dropzone,
    // Drag,
    // Drop,
  },
};
</script>

<style lang="scss">
.kd-image-dropzone {
  position: relative;
  border: 2px dashed #C6C6C6;
  border-radius: 0 0 4px 4px;

  &--dragover {
    border: 2px solid #00A3DF;
  }
}

.kd-image-dropzone__inner-wrapper {
  padding: 18px;
  width: 100%;
  height: 100%;

  @media all and (max-height: 680px) {
    padding: 12px;
  }
}

.kd-image-dropzone__dragover-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  background-color: #00A3DF;
  display: none;

  .kd-image-dropzone--dragover & {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.kd-image-dropzone__dragover-text {
  color: white;
  font-style: italic;
  font-size: 11px;
}

.kd-image-dropzone__dragndrop-hint {
  font-style: italic;
  color: #929292;
  text-align: center;
  margin-top: 16px;
  font-size: 11px;

  @media all and (max-height: 680px) {
    margin-top: 10px;
  }
}

.DELETE_ME_LATER_UPLOAD_URL { // TODO: Delete element
  position: fixed;
  bottom: 20px;
  left: 20px;
  font-size: 10px;
  opacity: 0.2;
}
// .kd-image-dropzone__dropzone {
//   width: 100%;
//   height: 100%;
// }
</style>
